/*
 * @Description: 
 * @Author: knx-xc
 * @LastEditTime: 2020-09-01 15:06:00
 * @LastEditors: knx-xc
 */ 

import http from '../http'


/**
 * @description:  登录
 * @params ：  
 */
export const login = (data = {}) => {
  let params = {
    method: 'post',
    api: '/sys/login',
    data: data
  }
  return http(params)
}

/**
 * @description:  退出
 * @params ：  
 */
export const logout = (data = {}) => {
  let params = {
    method: 'post',
    api: '/sys/logout',
    data: data
  }
  return http(params)
}




/**
 * @description: 图片上传
 * @params ：  
 */
export const upload = (data = {}) => {
  let params = {
    method: 'post',
    api: '/manage/common/upload',
    data: data
  }
  return http(params)
}


/**
 * @description: 页面列表下拉数据
 * @params ：  
 */
export const getPageSelectList = (data = {}) => {
  let params = {
    method: 'post',
    api: '/manage/common/getPageSelectList',
    data: data
  }
  return http(params)
}



/**
 *  获取域名  getDomain
 * 
 */

export const getDomain = (data = {}) => {
  let params = {
    method: 'get',
    api: '/manage/common/getDomain',
    data: data
  }
  return http(params)
}